import { ITranslations } from 'types/common';
import { RequestPopUpTransFields } from './types';
import en from 'translations/en/approveRequestPopUp.json';
import pl from 'translations/pl/approveRequestPopUp.json';
import sl from 'translations/sl/approveRequestPopUp.json';

export const requestPopUpTransFieldsTranslations: ITranslations<RequestPopUpTransFields> = {
  name: 'requestPopUpTransFields',
  en,
  pl,
  sl,
};
